"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCustomIcon = void 0;
const AdaptableContext_1 = require("../../AdaptableContext");
const useCustomIcon = (icon) => {
    const adaptable = (0, AdaptableContext_1.useAdaptable)();
    if (!icon) {
        return icon;
    }
    return adaptable.api.userInterfaceApi.internalApi.prepareAdaptableIconDef(icon);
};
exports.useCustomIcon = useCustomIcon;
